export default __webpack_public_path__ + "static/media/massup_background_l2.3081049b.jpg";